import styled from "styled-components";
import { Title } from "../ApplicationSection/styled";

export const PictureContainer = styled.div`
  display: grid;
  row-gap: 20px;
  column-gap: 5px;
  grid-template-columns: repeat(4, 1fr);
  justify-items: center;
  width: 100%;
  margin: auto;
  height: auto;
  padding: 20px 80px;
  /* position: relative; */

  @media only screen and (max-width: 560px) {
    grid-template-columns: repeat(1, 1fr);
    row-gap: 20px;
    column-gap: 0px;
    padding: 20px;
  }
`;

export const ImageWrap = styled.div`
  position: relative;
  width: 90%;
  padding-bottom: 80%;

  @media only screen and (max-width: 560px) {
    width: 100%;
    padding-bottom: 100%;
  }

  .pic {
    /* position: aboslute; */
  }
`;

export const WorkTitle = styled(Title)`
  font-size: 32px;
  letter-spacing: 0.5px;
  color: black;
  margin: 35px;
  font-family: "Lora medium";
  font-weight: normal;

  @media only screen and (max-width: 560px) {
    font-size: 28px;
    margin: 0px 0px 10px 0px;
    padding: 0px;
  }

  & > span {
    background-image: linear-gradient(white 35%, rgba(214, 213, 213, 0.5) 0%);
    display: inline;
    background-position: right 0px bottom 0px;
    padding: 0px 18px;
  }
`;
